/**
 * cardViewData — form/edit field definitions, split per module.
 *
 * Each module file exports `<module>Cards`; they are merged here into the single
 * `cardViewData` object consumed by CardView, CardEmbed and ModalViewCard.
 * Keys are globally unique — add a new card to its module file in alphabetical
 * order, never to this file.
 */
import { accountingCards    } from './cardViewData/accounting.js'
import { adminCards         } from './cardViewData/admin.js'
import { bankCards          } from './cardViewData/bank.js'
import { crmCards           } from './cardViewData/crm.js'
import { documentsCards     } from './cardViewData/documents.js'
import { inventoryCards     } from './cardViewData/inventory.js'
import { manufacturingCards } from './cardViewData/manufacturing.js'
import { projectCards       } from './cardViewData/project.js'
import { purchasesCards     } from './cardViewData/purchases.js'
import { salesCards         } from './cardViewData/sales.js'
import { serviceCards       } from './cardViewData/service.js'
import { studioCards        } from './cardViewData/studio.js'
import { warehouseCards     } from './cardViewData/warehouse.js'

export const cardViewData = {
    ...accountingCards,
    ...adminCards,
    ...bankCards,
    ...crmCards,
    ...documentsCards,
    ...inventoryCards,
    ...manufacturingCards,
    ...projectCards,
    ...purchasesCards,
    ...salesCards,
    ...serviceCards,
    ...studioCards,
    ...warehouseCards
}
